import React from 'react';
import { XMarkIcon, UserPlusIcon } from '@heroicons/react/24/outline';

/**
 * AssignToSpeakerModal Component
 *
 * Modal to choose a speaker when assigning the selected text (in one block) to that speaker.
 * Reuses the same speaker list as the sidebar.
 */
const AssignToSpeakerModal = ({
  isOpen,
  onClose,
  speakers = [],
  selectedTextPreview = '',
  onSelectSpeaker,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex: 100000 }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <UserPlusIcon className="h-5 w-5 text-blue-600" />
            Assign selection to speaker
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
          >
            <XMarkIcon className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          {selectedTextPreview && (
            <p className="text-sm text-gray-600 truncate" title={selectedTextPreview}>
              Selected: &quot;{selectedTextPreview}&quot;
            </p>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Choose speaker
            </label>
            {speakers.length === 0 ? (
              <p className="text-sm text-gray-500">No speakers in transcript. Add a speaker first.</p>
            ) : (
              <div className="space-y-1 max-h-64 overflow-y-auto">
                {speakers.map((speaker) => (
                  <button
                    key={speaker.name}
                    type="button"
                    onClick={() => onSelectSpeaker(speaker.name)}
                    className="w-full text-left px-3 py-2 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-200 transition-colors text-sm font-medium text-gray-800"
                  >
                    {speaker.name}
                    {speaker.count != null && (
                      <span className="text-gray-500 font-normal ml-1">({speaker.count} blocks)</span>
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignToSpeakerModal;
